(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvth-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function() {
  var scope = document.querySelector('[data-velvth-bestsellers="{{ section.id }}"]');
  if (!scope) return;

  var buttons = scope.querySelectorAll('[data-quick-add]');
  buttons.forEach(function(btn) {
    if (btn.dataset.velvthBound === 'true') return;
    btn.dataset.velvthBound = 'true';

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

      var hasVariants = btn.dataset.hasVariants === 'true';
      var variantId = btn.dataset.variantId;
      var productUrl = btn.dataset.productUrl;
      var label = btn.querySelector('[data-quick-add-label]');
      var originalText = label ? label.textContent : 'Add';

      if (hasVariants || !variantId) {
        window.location.href = productUrl;
        return;
      }

      btn.classList.add('is-loading');
      btn.classList.remove('is-error');
      if (label) label.textContent = 'Adding';

      var adder = (window.velvthCart && window.velvthCart.addItem)
        ? window.velvthCart.addItem(variantId, 1)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          })
          .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
          .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('velvth:cart:updated', { detail: cart }));
            return cart;
          });

      adder
      .then(function() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        if (label) label.textContent = 'Added';
        if (window.velvthCart && typeof window.velvthCart.open === 'function') {
          window.velvthCart.open();
        } else {
          document.dispatchEvent(new CustomEvent('velvth:cart:open'));
        }
        setTimeout(function() {
          btn.classList.remove('is-success');
          if (label) label.textContent = originalText;
        }, 1600);
      })
      .catch(function(err) {
        console.error('Quick add error:', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        if (label) label.textContent = 'Error';
        setTimeout(function() {
          btn.classList.remove('is-error');
          if (label) label.textContent = originalText;
        }, 1800);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvth-collection-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var scope = document.querySelector('[data-velvth-cp="{{ section.id }}"]');
  if (!scope) return;

  var buttons = scope.querySelectorAll('[data-quick-add]');
  buttons.forEach(function(btn) {
    if (btn.dataset.velvthBound === 'true') return;
    btn.dataset.velvthBound = 'true';

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

      var hasVariants = btn.dataset.hasVariants === 'true';
      var variantId = btn.dataset.variantId;
      var productUrl = btn.dataset.productUrl;
      var label = btn.querySelector('[data-quick-add-label]');
      var originalText = label ? label.textContent : 'Add';

      if (hasVariants || !variantId) {
        window.location.href = productUrl;
        return;
      }

      btn.classList.add('is-loading');
      btn.classList.remove('is-error');
      if (label) label.textContent = 'Adding';

      var adder = (window.velvthCart && window.velvthCart.addItem)
        ? window.velvthCart.addItem(variantId, 1)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          })
          .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
          .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('velvth:cart:updated', { detail: cart }));
            return cart;
          });

      adder
      .then(function() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        if (label) label.textContent = 'Added';

        if (window.velvthCart && typeof window.velvthCart.open === 'function') {
          window.velvthCart.open();
        } else {
          document.dispatchEvent(new CustomEvent('velvth:cart:open'));
        }

        setTimeout(function() {
          btn.classList.remove('is-success');
          if (label) label.textContent = originalText;
        }, 1600);
      })
      .catch(function(err) {
        console.error('Quick add error:', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        if (label) label.textContent = 'Error';
        setTimeout(function() {
          btn.classList.remove('is-error');
          if (label) label.textContent = originalText;
        }, 1800);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvth-featured-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  var scope = document.querySelector('[data-velvth-collection="{{ section.id }}"]');
  if (!scope) return;

  var buttons = scope.querySelectorAll('[data-quick-add]');
  buttons.forEach(function(btn) {
    if (btn.dataset.velvthBound === 'true') return;
    btn.dataset.velvthBound = 'true';

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

      var hasVariants = btn.dataset.hasVariants === 'true';
      var variantId = btn.dataset.variantId;
      var productUrl = btn.dataset.productUrl;
      var label = btn.querySelector('[data-quick-add-label]');
      var originalText = label ? label.textContent : 'Add';

      if (hasVariants || !variantId) {
        window.location.href = productUrl;
        return;
      }

      btn.classList.add('is-loading');
      btn.classList.remove('is-error');
      if (label) label.textContent = 'Adding';

      var adder = (window.velvthCart && window.velvthCart.addItem)
        ? window.velvthCart.addItem(variantId, 1)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          })
          .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
          .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('velvth:cart:updated', { detail: cart }));
            return cart;
          });

      adder
      .then(function() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        if (label) label.textContent = 'Added';

        if (window.velvthCart && typeof window.velvthCart.open === 'function') {
          window.velvthCart.open();
        } else {
          document.dispatchEvent(new CustomEvent('velvth:cart:open'));
        }

        setTimeout(function() {
          btn.classList.remove('is-success');
          if (label) label.textContent = originalText;
        }, 1600);
      })
      .catch(function(err) {
        console.error('Quick add error:', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        if (label) label.textContent = 'Error';
        setTimeout(function() {
          btn.classList.remove('is-error');
          if (label) label.textContent = originalText;
        }, 1800);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvth-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.__velvthHeaderNav === true) return;
  window.__velvthHeaderNav = true;

  window.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-menu-toggle]')) {
      e.preventDefault();
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      var nav2 = document.querySelector('[data-mobile-nav]');
      if (nav2) { nav2.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  }, true);

  window.addEventListener('scroll', function() {
    var header = document.getElementById('velvth-header');
    if (!header) return;
    if (window.scrollY > 10) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvth-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initProduct(sectionId) {
    var root = document.querySelector('[data-velvth-product="' + sectionId + '"]');
    if (!root) return;
    if (root.dataset.velvthProductReady === 'true') return;
    root.dataset.velvthProductReady = 'true';

var variantsScript = document.querySelector(
  '[data-product-variants-json][data-product-id="' +
  root.dataset.productId + '"]'
);
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

    var variantInput = root.querySelector('[data-variant-input]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var discountBadge = root.querySelector('[data-discount-badge]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-label]');
    

    var selectedOptions = [];
    if (variants.length && variantInput) {
      var initialVariant = variants.filter(function(v) {
        return String(v.id) === String(variantInput.value);
      })[0] || variants[0];
      if (initialVariant && initialVariant.options) {
        selectedOptions = initialVariant.options.slice();
      }
    }

    function findVariantByOptions(options) {
      return variants.filter(function(v) {
        if (!v.options || v.options.length !== options.length) return false;
        for (var i = 0; i < options.length; i++) {
          if (v.options[i] !== options[i]) return false;
        }
        return true;
      })[0];
    }


function formatMoney(cents) {
  if (typeof cents !== 'number') {
    cents = parseInt(cents, 10) || 0;
  }

  const amount = (cents / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return '€' + amount;
}


    function updateVariantUI(variant) {
      if (!variant || !variantInput) return;
      

var inventoryNotice = root.querySelector('[data-inventory-notice]');

if (inventoryNotice) {
  var quantity = Number(variant.inventory_quantity);

  if (!variant.available) {
    inventoryNotice.textContent = 'Sold out';
  } else if (variant.inventory_management === 'shopify') {
    inventoryNotice.textContent =
      Math.max(0, quantity) + ' in stock';
  } else {
    inventoryNotice.textContent = 'In stock';
  }
}


      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      var price = variant.price;
      var compare = variant.compare_at_price;

      if (priceCurrent) priceCurrent.textContent = formatMoney(price);
      if (priceCompare) {
        if (compare && compare > price) {
          priceCompare.textContent = formatMoney(compare);
          priceCompare.hidden = false;
        } else {
          priceCompare.textContent = '';
          priceCompare.hidden = true;
        }
      }
      if (discountBadge) {
        if (compare && compare > price) {
          var pct = Math.round(((compare - price) / compare) * 100);
          discountBadge.textContent = '-' + pct + '%';
          discountBadge.hidden = false;
        } else {
          discountBadge.hidden = true;
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.classList.remove('is-disabled');
          if (addLabel) addLabel.textContent = 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('is-disabled');
          if (addLabel) addLabel.textContent = 'Sold Out';
        }
      }
    }

    root.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-option-btn]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var optionIndex = parseInt(btn.dataset.optionIndex, 10);
      var value = btn.dataset.optionValue;
      selectedOptions[optionIndex] = value;

      var group = root.querySelector('[data-option-index="' + optionIndex + '"]');
      if (group) {
        var sibs = group.querySelectorAll('[data-option-btn]');
        for (var i = 0; i < sibs.length; i++) {
          sibs[i].classList.toggle('is-selected', sibs[i].dataset.optionValue === value);
        }
      }
      var variant = findVariantByOptions(selectedOptions);
      if (variant) updateVariantUI(variant);
    });

    var mainImages = root.querySelectorAll('[data-main-image]');
    var thumbsContainer = root.querySelector('[data-thumbnails]');
    if (thumbsContainer && mainImages.length > 1) {
      thumbsContainer.addEventListener('click', function(e) {
        var thumb = e.target.closest('[data-thumb]');
        if (!thumb || !thumbsContainer.contains(thumb)) return;
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(thumb.dataset.thumbIndex, 10);
        if (isNaN(idx)) return;
        for (var i = 0; i < mainImages.length; i++) {
          mainImages[i].classList.toggle('is-active', parseInt(mainImages[i].dataset.imageIndex, 10) === idx);
        }
        var thumbs = thumbsContainer.querySelectorAll('[data-thumb]');
        for (var j = 0; j < thumbs.length; j++) {
          thumbs[j].classList.toggle('is-active', parseInt(thumbs[j].dataset.thumbIndex, 10) === idx);
        }
      });
    }

    var qtyInput = root.querySelector('[data-qty-input]');
    if (qtyInput) {
      qtyInput.addEventListener('input', function() {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) qtyInput.value = 1;
      });
    }
  }

  var initialRoot = document.querySelector('[data-velvth-product]');
  if (initialRoot) initProduct(initialRoot.dataset.velvthProduct);

  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('[data-velvth-product]');
    if (s) initProduct(s.dataset.velvthProduct);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvth-you-may-also-like"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var root = document.querySelector('[data-velvth-yml="{{ section.id }}"]');
  if (!root || root.dataset.ymlInit === 'true') return;
  root.dataset.ymlInit = 'true';

  var configScript = document.querySelector('[data-yml-config="{{ section.id }}"]');

  /* ============ MODE 1: Recommendations fallback (no collection) ============ */
  if (configScript) {
    var config = {};
    try { config = JSON.parse(configScript.textContent); } catch (e) { return; }
    if (!config.productId) return;

    var grid = root.querySelector('[data-yml-grid]');
    if (!grid) return;

    var endpoint = '/recommendations/products?section_id=velvth-you-may-also-like&product_id='
      + config.productId
      + '&limit=' + (config.limit || 4)
      + '&intent=' + (config.intent || 'related');

    fetch(endpoint, { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.text() : ''; })
      .then(function(html) {
        if (!html) return hideSection();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionEl = doc.querySelector('[data-velvth-yml]');
        if (!sectionEl) return hideSection();
        var cards = sectionEl.querySelectorAll('.velvth-yml-card');
        if (!cards.length) return hideSection();

        grid.innerHTML = '';
        var max = Math.min(cards.length, config.limit || 4);
        for (var i = 0; i < max; i++) {
          grid.appendChild(document.importNode(cards[i], true));
        }
      })
      .catch(function() { hideSection(); });

    function hideSection() {
      var section = root.closest('section.velvth-yml');
      if (section && section.parentNode) section.parentNode.removeChild(section);
    }
    return;
  }

  /* ============ MODE 2: Collection mode (rendered server-side) ============ */
  /* Nothing to do — products are already in the DOM.
     Quick-add buttons are handled by the global window.velvthCart delegation. */
})();

  } catch(e) { console.error(e); }
})();
})();
